/**
 * ChromeProxy
 * This should probably just be rolled up into ChromeWrapper.
 */

namespace SmartVideo {
export class ChromeProxy {
    started: boolean;
    starting: boolean;
    browser: string;
    isSmartVideoAgent: boolean;
    startDisallowed: boolean;
    dispatchFunction: Function;
    receivedEvent: EventListener;
    sendRequest: Function;
    sendEvent: Function;
    videoHandler: VideoHandler;

    constructor(browser, videoHandler, sendEvent, receivedEvent) {
        this.videoHandler = videoHandler;
        this.sendRequest = sendEvent;
        this.sendEvent = sendEvent;
        this.receivedEvent = receivedEvent;
        this.started = false;
        this.starting = false;
        this.browser = browser;
        this.isSmartVideoAgent = false;
        if (browser === 'SmartVideoAgent') {
            this.isSmartVideoAgent = true;
        }

    }

    connect() {
        window.addEventListener('message', this.receivedEvent, false);
    }

    disconnect() {
        window.removeEventListener('message', this.receivedEvent);
    }

    setOutEventDispatchMethod(method) {
        this.dispatchFunction = method;
    }

    useVideoElem(videoElement, callback) {
        console.log('ChromeProxy.useVideoElem called');
        this.videoHandler.start(videoElement, callback);
    }

    start(chromeNMSVersion, callback, timeout) {
        this.starting = true;
        /*
        Adding this code to ensure Native Messaging Host is connected.
        Vidyo added a listener to window.unload that sends a TabUnload to background.js
        When they added the listener, this broke our code, because we expect by the time we get here that the NMS is already connected
        Sending RequestConnectVersion causes background.js to connect to NMS
        */
        if (!this.isSmartVideoAgent) {
            const connectVersionRequest = {
                type: 'RequestConnectVersion',
                version: chromeNMSVersion
            }
            console.log('Sending connect version before InEventStart in ChromeProxy');
            this.sendEvent(connectVersionRequest, connectRequest => {
                this.sendEvent({ type: 'InEventStart' }, startRequest => {
                    this.startRequest(startRequest, callback);
                });
            });
        } else {
            // SmartVideoAgent handles lifetime of NMS, so no need to request a connect
            this.sendEvent({ type: 'InEventStart' }, request => {
                    this.startRequest(request, callback);
            });
        }

    }

    startRequest(request, callback) {
        this.starting = false;
        console.log(request);
        if (request.error && !this.isSmartVideoAgent) {
            if (request.error === 'VidyoClient already started') {
                this.startDisallowed = true;
                this.dispatchFunction({type: 'OutEventPluginConnectionFailure'});
            } else {
                this.dispatchFunction({type: 'OutEventPluginError', error: request.error});
            }
        } else {
            if (!this.isSmartVideoAgent) {
                this.sendEvent({type: 'ActiveTab'}, null);
            }
            this.started = true;
            this.dispatchFunction({type: 'OutEventPluginConnectionSuccess'});
        }
        if (callback) {
            callback(request);
        }
    }

    stop(callback, timeout) {
        console.log(`Started: ${this.started}, Disallowed: ${this.startDisallowed}, Starting: ${this.starting}`);
        if (!this.started && !this.startDisallowed || this.starting) {
            this.sendEvent({type: 'InEventStop'}, request => {
                this.started = false;
                if (!request.error) {

                }
                if (callback) {
                    callback(request);
                }
            });
        }
    }

    stopPlayback() {
        this.videoHandler.stop();
    }
}
}
